import { render } from "./SolucaoInformacoesGeraisForm.vue?vue&type=template&id=9ab1b398&scoped=true"
import script from "./SolucaoInformacoesGeraisForm.vue?vue&type=script&lang=js"
export * from "./SolucaoInformacoesGeraisForm.vue?vue&type=script&lang=js"

import "./SolucaoInformacoesGeraisForm.vue?vue&type=style&index=0&id=9ab1b398&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ab1b398"]])

export default __exports__